import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Index from "./pages/Index";
import Forum from "./pages/Forum";
import Auth from "./pages/Auth";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import LogoOptions from "./pages/LogoOptions";
import Statistics from "./pages/Statistics";
import ForumDesigns from "./pages/ForumDesigns";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/forum" element={<Forum />} />
            
            <Route path="/auth" element={<Auth />} />
            <Route path="/konto" element={<Account />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/integritetspolicy" element={<PrivacyPolicy />} />
            <Route path="/logo-options" element={<LogoOptions />} />
            <Route path="/statistik" element={<Statistics />} />
            <Route path="/forum-designs" element={<ForumDesigns />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
